import { UserServiceClient } from 'fitbeat.api-clients';
import { IUserLeaderboardViewModel } from 'fitbeat.models';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {
  ActivityIndicator, ScrollView, StyleSheet, Text, View,
} from 'react-native';
import Theme from '../theme';
import { LeaderboardTile } from '../Tracking/components/LeaderboardTile';
import { defaultScale } from '../utils';
import { createUserServiceClient } from '../utils/apiClientFactory';

interface IProps {
  t: (key: string, options?: any) => string;
  navigation: any;
  overrideLeaderboardParams: {
    leaderboard: IUserLeaderboardViewModel,
    team: string,
  }
  onModalUserScorePress?: (userProfileId: string, userName: string) => void;
  myCurrentLeaderboardTeam?: string;
}

interface IState {
  leaderboard: IUserLeaderboardViewModel | undefined;
  isLoading: boolean;
  error: Error | null;
  isMyCurrentTeam: boolean;
}

class LeaderboardTeamScreen extends Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = {
      leaderboard: undefined,
      isLoading: false,
      error: null,
      isMyCurrentTeam: false,
    };
  }

  public async componentDidMount() {
    const { navigation, overrideLeaderboardParams } = this.props;
    const {
      leaderboard,
      team,
    }: { leaderboard: IUserLeaderboardViewModel, team: string } = overrideLeaderboardParams || navigation.state.params;
    const myTeamInfo = leaderboard.rankings.find((ranking) => ranking.isMine);
    this.setState({ isMyCurrentTeam: myTeamInfo?.name === team });
    const userServiceClient: UserServiceClient = createUserServiceClient();
    this.setState({ isLoading: true });
    try {
      const leaderboardTeamData = await userServiceClient.getLeaderboardDataForTeam(
        leaderboard.leaderboardId,
        leaderboard.startDate,
        leaderboard.endDate,
        team,
      );
      this.setState({ leaderboard: { ...leaderboardTeamData, requireOptIn: false } });
    } catch (e: any) {
      this.setState({ error: e });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  public render() {
    const { t, navigation } = this.props;
    const { leaderboard, error } = this.state;

    if (this.state.isLoading) {
      return (
        <ActivityIndicator
          size='large'
          animating
          color={Theme.PRIMARY}
          style={styles.loader}
        />
      );
    }

    return (
      <ScrollView>
        {error && (
        <View>
          <Text style={styles.errorText}>
            Oops something went wrong! Please try again.
          </Text>
        </View>
        )}
        {leaderboard && (
        <View>
          <LeaderboardTile
            leaderboard={leaderboard}
            t={t}
            navigation={navigation}
            summary={false}
            teamMembersOverview
            isFeatured={false}
            showRankings
            showJoinLeaderboardTile={false}
            onModalUserScorePress={this.props.onModalUserScorePress}
            isMyCurrentTeam={this.state.isMyCurrentTeam}
          />
        </View>
        )}
      </ScrollView>
    );
  }
}

const styles = StyleSheet.create({
  loader: {
    height: defaultScale(300),
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: defaultScale(20),
    alignSelf: 'center',
  },
  errorText: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
    marginTop: defaultScale(20),
  },
});

export default translate(['tracking, dashboard'], { wait: true })(LeaderboardTeamScreen);
